<div class="input-wrapper">
  <input
    #minuteInput
    type="text"
    placeholder="0h00"
    [value]="displayValue"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput($event)"
    [disabled]="isDisabled"
    class="form-control"
    autocomplete="off"
    autocapitalize="none"
    spellcheck="false"
  />

  <div class="arrows-container">
    <button
      type="button"
      class="arrow-btn"
      [disabled]="isDisabled"
      (mousedown)="onArrowMouseDown('up')"
      (mouseup)="onArrowMouseUp()"
      (mouseleave)="onArrowMouseLeave()"
    >
      ▲
    </button>
    <button
      type="button"
      class="arrow-btn"
      [disabled]="isDisabled"
      (mousedown)="onArrowMouseDown('down')"
      (mouseup)="onArrowMouseUp()"
      (mouseleave)="onArrowMouseLeave()"
    >
      ▼
    </button>
  </div>
</div>
